import { Box, Button, Divider, Stack, Typography } from "@mui/material";

import DirectionsIcon from "@mui/icons-material/Directions";
import LocationOnIcon from "@mui/icons-material/LocationOn";
// import TrainIcon from "@mui/icons-material/Train";
import {
  Train as TrainIcon,
  LocalAirport as LocalAirportIcon,
  // FlightTakeoff as FlightIcon,
  DirectionsBus as DirectionsBusIcon,
  LocalTaxi as LocalTaxiIcon,
} from "@mui/icons-material";

// Icon Mapper Helper
const getTransportIcon = (iconName) => {
  switch (iconName) {
    case "SubwayIcon":
      return <TrainIcon sx={{ fontSize: 20, color: "text.secondary" }} />;
    case "BusIcon":
      return (
        <DirectionsBusIcon sx={{ fontSize: 20, color: "text.secondary" }} />
      );
    case "TrainIcon":
      return <TrainIcon sx={{ fontSize: 20, color: "text.secondary" }} />;
    case "FlightIcon":
      return (
        <LocalAirportIcon sx={{ fontSize: 20, color: "text.secondary" }} />
      );
    case "TaxiIcon":
      return <LocalTaxiIcon sx={{ fontSize: 20, color: "text.secondary" }} />;
    default:
      return <TrainIcon sx={{ fontSize: 20, color: "text.secondary" }} />;
  }
};

const MapPopup = ({ property = {} }) => {
  // Helper to construct the Google Maps Directions URL
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${property.lat},${property.lng}`;
  // const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=25.5,85.1&destination=${property.lat},${property.lng}`;

  const nearestTransport = property.nearbyTransport?.[0];

  return (
    <Box sx={{ p: 0.5 }}>
      {/* 1. Precise Address Header */}
      <Stack direction="row" spacing={1} alignItems="flex-start" mb={1}>
        <LocationOnIcon
          sx={{
            color: "text.secondary",
            fontSize: 20,
            mt: 0.3,
          }}
        />
        <Box>
          <Typography variant="subtitle2" fontWeight="700" lineHeight={1.2}>
            {property.address.buildingName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {[property.address.street, property.address.area]
              .filter(Boolean)
              .join(", ")}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ my: 1 }} />

      {/* 2. Micro-Context (Transport) */}
      {nearestTransport && (
        <Stack direction="row" spacing={1} alignItems="center" mb={1.5}>
          {getTransportIcon(nearestTransport.icon)}
          <Typography variant="caption">
            {/* {nearestTransport.stationName} •{" "} */}
            {[nearestTransport.stationName, " "].filter(Boolean).join(" • ")}
            <strong>{nearestTransport.distanceMetres}m away</strong>
          </Typography>
        </Stack>
      )}

      {/* 3. The Action: Industry Standard CTA */}
      <Button
        variant="outlined"
        size="small"
        fullWidth
        startIcon={<DirectionsIcon />}
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          textTransform: "none",
          borderRadius: "6px",
          fontWeight: 600,
        }}
      >
        Get Directions
      </Button>
    </Box>
  );
};

export default MapPopup;
